import { useState } from "react";
import { Link } from "react-router-dom";
import { GraduationCap, Loader2, CheckCircle2 } from "lucide-react";
import api from "@/lib/api";

export function EscalateBox({ conversationId }) {
    const [step, setStep] = useState("idle");
    const [note, setNote] = useState("");
    const [ticket, setTicket] = useState(null);
    const [error, setError] = useState("");

    const send = async () => {
        setStep("sending"); setError("");
        try {
            const { data } = await api.post("/assistant/escalate", { conversation_id: conversationId, message: note.trim() || null });
            setTicket(data); setStep("done");
        } catch (e) {
            setError(e?.response?.data?.detail || "Envoi impossible."); setStep("form");
        }
    };

    if (step === "done" && ticket) {
        return (
            <div className="rounded-xl p-3.5 text-xs" style={{ background: "rgba(117,138,101,0.18)", color: "var(--text-on-dark)", border: "1px solid rgba(117,138,101,0.4)" }} data-testid="escalate-success">
                <div className="flex items-center gap-1.5 font-semibold mb-1"><CheckCircle2 className="w-4 h-4" /> Question transmise</div>
                {ticket.teacher_name ? `Le professeur ${ticket.teacher_name} va vous répondre.` : "L'équipe pédagogique va vous répondre."}{" "}
                <Link to={`/messages/${ticket.id}`} className="underline" style={{ color: "var(--gold-200)" }} data-testid="escalate-open-thread-link">Suivre la conversation</Link>
            </div>
        );
    }

    if (step === "idle") {
        return (
            <button
                onClick={() => setStep("form")}
                className="w-full rounded-xl px-3.5 py-2.5 text-xs flex items-center justify-center gap-2 transition-colors hover:bg-white/10"
                style={{ border: "1px solid var(--gold-400)", color: "var(--gold-200)" }}
                data-testid="escalate-open-btn"
            >
                <GraduationCap className="w-4 h-4" /> Oui, transmettre ma question à un professeur
            </button>
        );
    }

    return (
        <div className="rounded-xl p-3 space-y-2" style={{ background: "rgba(244,238,223,0.05)", border: "1px solid var(--border-dark)" }} data-testid="escalate-form">
            <div className="text-xs" style={{ color: "var(--text-on-dark-soft)" }}>
                Votre échange avec l'assistant sera joint. Ajoutez une précision si besoin :
            </div>
            <textarea value={note} onChange={(e) => setNote(e.target.value)} rows={2} maxLength={4000}
                className="w-full rounded-lg px-3 py-2 text-sm outline-none resize-none"
                style={{ background: "rgba(244,238,223,0.07)", color: "var(--text-on-dark)", border: "1px solid var(--border-dark)" }}
                placeholder="Ce que je n'ai pas compris…" data-testid="escalate-note-input" />
            {error && <div className="text-xs" style={{ color: "#E8A0A0" }} data-testid="escalate-error">{error}</div>}
            <div className="flex gap-2 justify-end">
                <button onClick={() => setStep("idle")} className="text-xs px-3 py-1.5" style={{ color: "var(--text-on-dark-soft)" }} data-testid="escalate-cancel-btn">Annuler</button>
                <button onClick={send} disabled={step === "sending"} className="btn-gold !text-xs !px-3.5 !py-1.5" data-testid="escalate-send-btn">
                    {step === "sending" ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : "Transmettre au professeur"}
                </button>
            </div>
        </div>
    );
}
